$(document).ready(function () {
  /*var trustpilot_children = document.getElementById("trustpilot-widget").childNodes;
    var trustpilot_frame = trustpilot_children[0];
    trustpilot_frame.onload = function() {
        var date_tags = trustpilot_frame.contentDocument.getElementsByClassName("tp-widget-wrapper");
        date_tags.style.display = "none";
    }*/
  //var iframe = $('#tp iframe');
  //console.warn(iframe.contents().find(".tp-widget-wrapper"));
  //iframe.contents().find(".tp-widget-wrapper").css('background-color', 'black');
  /*$("#tp iframe").on("load", function() {
    let head = $("#tp iframe").contents().find("head");
    console.warn(head);
    let css = '<style>/********* Put your styles here **********</style>';
    $(head).append(css);
  });*/
  $("#blogFeatured").slick({
    prevArrow: '<button type="button" class="slickArrow slickArrow--prev"><i class="fa fa-angle-left text-white"></button>',
    nextArrow: '<button type="button" class="slickArrow slickArrow--next"><i class="fa fa-angle-right text-white"></i></button>',
  });
  var canHover = !matchMedia("(hover: none)").matches;
  if (canHover) {
    document.body.classList.add("canHover");
  }
  $("#filterForm input[type=checkbox]").on("change", function () {
    $("#filterForm").submit();
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() > 151) {
      $("#primaryNav").addClass("fixed");
    } else {
      $("#primaryNav").removeClass("fixed");
    }
  });
  $("#toggleNav").click(function (e) {
    e.preventDefault();
    $("#primaryNav").toggleClass("open");
    $("#newHeader").toggleClass("navIsOpen");
  });
  $(".backToMain").click(function (e) {
    $(".newNav__subnav.open").addClass("closed");
    $(".newNav__subnav.open").removeClass("open");
    $(".nav__toggler").show();
    e.preventDefault();
  });
  $(".openSubNav").click(function (e) {
    var navItem = $(this).attr("data-nav");
    $("#" + navItem).addClass("open");
    $(".nav__toggler").hide();
    e.preventDefault();
  });
  /*$('.newNav > ul > li > a').addEventListener('touchstart', function(e) {
        console.log('Helo');
        e.preventDefault();
    }, false);*/
});
